import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	Button,
	Checkbox,
	Typography,
	Box,
	Alert
} from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useUser } from '../hooks/useUser'
import useRole from '../hooks/useRole'

export const ManageUsers = () => {
	const navigate = useNavigate()
	const { loadingList, users, deactivateUser } = useUser()
	const { canManageUsers, canWrite } = useRole()

	const handleEditUser = (userId) => {
		navigate('/home/editar-usuario', { state: { userId } })
	}

	const handleDeactivateUser = async (userId) => {
		if (window.confirm('¿Estás seguro de que deseas eliminar este usuario?')) {
			if (await deactivateUser(userId)) {
				alert('Usuario eliminado correctamente')
			}
		}
	}

	if (loadingList) {
		return (
			<Typography variant="h6" align="center">
				Cargando usuarios...
			</Typography>
		)
	}

	return (
		<Box
			sx={{
				maxWidth: 1200,
				margin: 'auto',
				p: 2,
				marginTop: 10
			}}
		>
			{!canManageUsers() && (
				<Alert severity="error" sx={{ mb: 2 }}>
					No tienes permisos para administrar usuarios. Solo los administradores pueden realizar esta acción.
				</Alert>
			)}
			
			<Typography variant="h5" component="h1" align="center" gutterBottom pb={2}>
				Usuarios
			</Typography>
			<TableContainer component={Paper}>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell>Nombres</TableCell>
							<TableCell>Apellidos</TableCell>
							<TableCell>Correo Electrónico</TableCell>
							<TableCell>Roles</TableCell>
							<TableCell>Activo</TableCell>
							<TableCell>Acciones</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{users.map((user, index) => (
							<TableRow key={index}>
								<TableCell>{user.firstname}</TableCell>
								<TableCell>{user.lastname}</TableCell>
								<TableCell>{user.email}</TableCell>
								<TableCell>{user.role}</TableCell>
								<TableCell>
									<Checkbox checked={user.active} disabled />
								</TableCell>
								<TableCell>
									<Button
										variant="contained"
										size="small"
										color="primary"
										sx={{ mr: 1 }}
										onClick={() => handleEditUser(user.uid)}
										disabled={!canWrite()}
									>
										Editar
									</Button>
									<Button
										variant="outlined"
										size="small"
										color="error"
										onClick={() => handleDeactivateUser(user.uid)}
										disabled={!canWrite()}
									>
										Eliminar
									</Button>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</Box>
	)
}
